module.exports = __webpack_public_path__ + "static/0007-c31228a90762f2f8ce29b0696c034101.jpg";